'use strict';

var React = require('react');

var SvgAddNoteMajor = function SvgAddNoteMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.379 0a1.5 1.5 0 0 1 1.06.44l4.122 4.12a1.5 1.5 0 0 1 .439 1.062v4.378a6 6 0 0 0-6 6v4h-6.5a1.5 1.5 0 0 1-1.5-1.5v-17a1.5 1.5 0 0 1 1.5-1.5h6.879zm-5.379 5h8v2h-8v-2zm5 4h-5v2h5v-2zm-5 4h3v2h-3v-2zm14.707 2.293a1 1 0 0 0-.707-.293h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 .707-1.707z",
    fillRule: "evenodd"
  }));
};

exports.SvgAddNoteMajor = SvgAddNoteMajor;
